export default "__VITE_ASSET__CPTPJMD8__"